import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './wish-explanation';

const mainimage = '/Images/wish1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "wish" },
];

const Wish = () => (
  <GrammarPageLayout
    level="B2"
    title="Wish"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English “Wish” Grammar Exercises"
    seoDescription="Express wishes and regrets about present, past, and future. C1 level practice."
    relatedCategory="grammar-exercises"
    relatedLevel="C1"
  />
);

export default Wish;

